<div class="page tracking history">
  <app-left-track [trackingMode]="true" [visibleComponents]="'objects'"></app-left-track>

  <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
    <span><i></i></span>
  </div>

  <div class="righttrack">
    <div class="bottomright" id="bottomright">
      <div class="navblock">
        <button class="btnadd">{{'Add service task' | translate }}</button>
      </div>
      <div class="rightreport">
        <div id="servicetasks_info" class="tablewrap resizetable tabpage">
          <div class="table">
            <table fixedcols="[6]" id="servicetaskstable">
              <tr>
                <th>{{'Task'|translate }}</th>
                <th>{{'Object'|translate }}</th>
                <th>{{'Completion plan'|translate }}</th>
                <th>{{'Last works'|translate }}</th>
                <th>{{'Repeat'|translate }}</th>
                <th>{{'Status'|translate }}</th>
                <th></th>
              </tr>
            </table>
          </div>
          <app-pagination [viewmode]="'print excel reports'" [printElementID]="'servicetaskstable'"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
